import { ISpam } from './../../store/models/spam.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ETableColumnType, ITableColumn, ITableDataSource } from 'app/store/models/table.model';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { Router } from '@angular/router';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { SessionService } from 'app/store/services/session.service';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { takeUntil } from 'rxjs/operators';
import { IUserSessionData, UserType } from 'app/store/models/user.model';
import { deleteSpam, setMessagesList, setSpam } from 'app/store/actions/message.action';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { updateLeftMenuCount } from 'app/store/actions/meeting.action';

@Component({
  selector: 'app-spam-listing',
  templateUrl: './spam-listing.component.html',
  styleUrls: ['./spam-listing.component.scss'],
})
export class SpamListingComponent implements OnInit, OnDestroy {
  tableDataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'action_data1',
    sortDir: 'desc',
    filters: {},
  };
  tableColumns: ITableColumn<ISpam>[];
  dataSource: ITableDataSource;
  deleteAllButtonProperties: Button = {
    onClick: () => this.deleteAllSpam(),
    size: ButtonSize.SMALL,
    text: 'Delete all',
    color: ButtonColor.RED,
  };
  tableReady: boolean;
  sessionData: IUserSessionData;
  private destroy: Subject<boolean> = new Subject();

  constructor(
    private http: HttpClient,
    private router: Router,
    private leftMenu: LeftMenuService,
    private store: Store<IReducers>,
    private sessionService: SessionService,
  ) {
    const apiEndpoint = environment.apiUrl + '/v1/messages/spam';
    this.dataSource = new ApiDataSource<ISpam>(this.http, apiEndpoint);
    this.leftMenu.expand('inbox');
  }

  rowClass = (row: ISpam) => 'route_message ' + row.message_status;

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        const columns: ITableColumn<ISpam>[] = [
          {
            id: 'contact_firstname',
            title: 'Contact',
            renderer: row => {
              let contactName = row.contact_email;

              if (row.contact_firstname && row.contact_lastname) {
                contactName = `${row.contact_firstname} ${row.contact_lastname}`;
              }
              return contactName;
            },
            route: row => this.onColumnClick(row),
          },
          {
            id: 'contact_company',
            title: 'Company',
            route: row => this.onColumnClick(row),
          },
          {
            id: 'not_span',
            title: 'Not spam',
            type: ETableColumnType.BUTTON,
            buttonProperties: {
              color: ButtonColor.ORANGE,
              onClick: row => this.notASpam(row),
              size: ButtonSize.SMALL,
              text: 'Not Spam',
            },
          },
        ];

        if (sessionData.user_type !== UserType.SINGLE_USER) {
          columns.push({
            id: 'account_firstname',
            title:
              sessionData.user_type === UserType.MASTER
                ? 'Account'
                : 'Representative',
            sortable: true,
            renderer: row => {
              return `${row.account_firstname} ${row.account_lastname}`;
            },
            route: row => this.onColumnClick(row),
          });
        }

        this.tableColumns = columns;
        this.tableReady = true;
      });
  }

  ngOnDestroy() {
    this.destroy.next(false);
  }

  onColumnClick(item: ISpam) {
    this.router.navigate([
      '/messages/view',
      item.message_id,
      {
        from: 'spam',
      },
    ]);
  }

  onData = (items: ISpam[]) => {
    this.store.dispatch(
      setMessagesList({ list: items.map(item => item.message_id) }),
    );
  };

  notASpam(item) {
    this.store.dispatch(setSpam({ id: item.message_id, spam: false }));
    const apiEndpoint = environment.apiUrl + '/v1/messages/spam';
    this.dataSource = new ApiDataSource<ISpam>(this.http, apiEndpoint);
    this.store.dispatch(updateLeftMenuCount({ data: {} }));
  }

  deleteAllSpam() {
    this.store.dispatch(deleteSpam());
    const apiEndpoint = environment.apiUrl + '/v1/messages/spam';
    this.dataSource = new ApiDataSource<ISpam>(this.http, apiEndpoint);
    this.store.dispatch(updateLeftMenuCount({ data: {} }));
  }
}
